import React, { useEffect, useState } from 'react';
import { Select, Row, Col, Button, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { getHubspotDeals, createPricingDeal, createPricingTemplate } from '../../services/Apis';
import LogoutPopUp from '../../components/LogoutPopUp';
import PricingTemplateDetails from '../components/PricingTemplateDetails';
import { PricingTemplateData } from '../interfaces/interfaces';
import { validateInputs } from '../services/services';
import dayjs from 'dayjs';


const { Option } = Select;
const { Text } = Typography;

const CreatePricingTemplate: React.FC = () => {
  const templateDetails: PricingTemplateData = {
    'Template Name': '',
    'Template Description': '',
    'Engagement Type': '',
    'Expected Start Date': dayjs(new Date()).format("YYYY-MM-DDTHH:mm:ss"), // Format as needed
    'Duration': 1,
    'Pricing Contributors': [],
    'Base Price Version ID': 2,
  };

  // Options for the dropdowns
  const [selectedDetails, setSelectedDetails] = useState<any>({});
  const [createDealError, setCreateDealError] = useState<string | null>(null);
  const [selectedTemplateDetails, setSelectedTemplateDetails] = useState<boolean>(false);
  const [tokenExpired, setTokenExpired] = useState<boolean>(false);

  const createBlankTemplate = async () => {
    if (!selectedTemplateDetails) {
      setCreateDealError("Please fill all the fields marked with '*'");
      return;
    }
    const createTemplate = await createPricingTemplate(selectedDetails);
    if (createTemplate.error_status === 401) {
      setTokenExpired(true);
    } else {
      if (createTemplate.error) {
        console.error('Error Response Data:', createTemplate.error);
        console.error('Error Response Status:', createTemplate.error_status);
        setCreateDealError(createTemplate.error);
      } else {
        navigate(`/pricing-template?templateId=${createTemplate.template_id}&templateName=${encodeURIComponent(createTemplate.template_name)}`);
      }
    }
  }



  const navigate = useNavigate(); // React Router hook for navigation

  const handleDataFill = (data: any) => {
    const toValidateInputs = { ...data };
    delete toValidateInputs['Template Description'];
    delete toValidateInputs['Base Price Version Name'];
    if (validateInputs(toValidateInputs).length === 0) {
      const formattedData = {
        'template_name': data['Template Name'],
        'template_description': data['Template Description'],
        'engagement_type': data['Engagement Type'],
        'project_start_date': data['Expected Start Date'],
        'duration_in_months': data['Duration']
      }
      setSelectedDetails(formattedData);
      setSelectedTemplateDetails(true)
    } else {
      setSelectedTemplateDetails(false)
    }
  };
  return tokenExpired ? (<LogoutPopUp openPopup={tokenExpired} />) : (
    <Row gutter={16}>
      {createDealError && <Text type="danger">{createDealError}</Text>}
      {/* Hubspot Deals */}
      <Col span={24}>
        <PricingTemplateDetails dataSrc={templateDetails} onEdit={handleDataFill} pricingContributors={[]} />
      </Col>
      <Col span={24}>
        <Button disabled={!selectedTemplateDetails} style={{ width: '100%' }} className='custom-button' onClick={createBlankTemplate}>
          Create New Pricing
        </Button>
      </Col>
    </Row>
  );
};

export default CreatePricingTemplate;
